import styled from '@emotion/styled';

import { useCloudinaryPictureOverlay } from '../../../OC/oc-picture-overlay';

const StyleboardSlide = styled.a`
  display: inline-block;
  margin-bottom: 0.5em;
  position: relative;
  width: 100%;
`;

const StyleboardImage = styled.div`
  background-image: url('${props => props.background.desktop}');
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  display: inline-block;
  margin: 0 0 2em;
  padding-bottom: 40%;
  position: relative;
  width: 100%;

  @media (max-width: 1050px) {
    background-image: url('${props => props.background.tablet}');
  }
`;

const StyleboardTitle = styled.div`
  color: #000000;
  display: inline-block;
  font-size: 1.714em;
  font-weight: 300;
  line-height: 120%;
  position: relative;
  text-align: center;
  width: 100%;

  @media (max-width: 1050px) {
    font-size: 1.5em;
  }

  @media (max-width: 768px) {
    font-size: 1.2em;
  }

  .reg {
    display: inline-block;
    font-size: 0.6em;
    line-height: 1em;
    position: relative;
    vertical-align: top;
  }
`;

const WidgetSlide = props => {
  const { title, url, tracking, baseLayer, overlays } = props;

  const { imageUrl: desktopImageUrl } = useCloudinaryPictureOverlay({
    baseLayer: baseLayer.desktop,
    overlays: overlays.desktop,
  });
  const { imageUrl: tabletImageUrl } = useCloudinaryPictureOverlay({
    baseLayer: baseLayer.tablet,
    overlays: overlays.tablet,
  });
  const background = {
    desktop: desktopImageUrl,
    tablet: tabletImageUrl,
  };

  return (
    <StyleboardSlide draggable="false" href={url} target="_blank" {...tracking}>
      <StyleboardImage background={background} />
      <StyleboardTitle dangerouslySetInnerHTML={{ __html: title }} />
    </StyleboardSlide>
  );
};

export default WidgetSlide;
